module.exports = __webpack_public_path__ + "assets/patrick-8e59289769d87ee36b8cae43d3a2955a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/data/images/patrick.jpg
// module id = 520
// module chunks = 1